const toNumber = (value: string | number, precision: number | undefined = 2): number => {
  const number = Number(value)
  return isNaN(number) ? 0 : precision ? +number.toFixed(precision) : number
}

export default toNumber
